/**
 * These phone numbers are used in all components
 * Change them here and all components will get them.
 */
export const PHONE_NUMBER = '0483904257';
export const PHONE_NUMBER_FORMATTED = '0483 904 257';
